var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.779,
    height: 19.013,
    viewBox: "0 0 23.779 19.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(-2437.518 -201.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M2461.3,206.893c-.306.3-.615.6-.919.907-.249.248-.493.5-.742.755a14.449,14.449,0,0,0-20.447-.025l-1.671-1.671c.233-.218.464-.462.723-.672.571-.463,1.138-.935,1.74-1.355a15.667,15.667,0,0,1,3.447-1.805,16.762,16.762,0,0,1,6.325-1.092,16.605,16.605,0,0,1,7.725,2.067,16.865,16.865,0,0,1,3.343,2.42c.16.148.318.3.476.445Z",
    fill: "#417eba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M2457.945,210.227l-1.671,1.66a9.714,9.714,0,0,0-13.748,0l-1.668-1.659A12.026,12.026,0,0,1,2457.945,210.227Z",
    fill: "#417eba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M2444.222,213.553a7.3,7.3,0,0,1,10.368.011l-1.677,1.661a4.97,4.97,0,0,0-7.025,0Z",
    fill: "#417eba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M2449.217,220.7a4.115,4.115,0,0,1-.414-.1,1.823,1.823,0,0,1-1.251-1.432,1.8,1.8,0,0,1,.725-1.887c.465-.349,4.25-7.537,6.107-11.1a.21.21,0,0,1,.387.156c-1.156,3.884-3.489,11.805-3.462,12.349a1.874,1.874,0,0,1-1.524,1.975l-.176.038Z",
    fill: "#417eba",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIot);
export default __webpack_public_path__ + "static/media/iot.670d522be15543216f40734e80392288.svg";
export { ForwardRef as ReactComponent };